
    import './styles.scoped.css';
    export default {
  "button": "awsui_button_m5h9f_jh0av_94",
  "expanded": "awsui_expanded_m5h9f_jh0av_126",
  "offset-right-none": "awsui_offset-right-none_m5h9f_jh0av_137",
  "offset-right-l": "awsui_offset-right-l_m5h9f_jh0av_140",
  "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_jh0av_143",
  "text": "awsui_text_m5h9f_jh0av_165",
  "icon": "awsui_icon_m5h9f_jh0av_169"
};
  